import React, { useState, useEffect } from "react";
import api from "../../api";
import useProceduresPartners from "../../views/partners/hooks/useProceduresPartners";
import Swal from "sweetalert2";
import EditarProcedimento from "./EditarProcedimento.js";
import Loading from "../Loading";
import excluir from "../../assets/img/remover.svg";
import editar from "../../assets/img/botao-editar-black.svg";
import { NumericFormat } from "react-number-format";
import formatMoney from '../../utils/formatMoney.js'

const ProcedimentosModal = ({ isModalOpen, closeModal, id }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedProcedures, setSelectedProcedures] = useState([]);
  const {
    proceduresPartners,
    setProceduresPartners,
    loadingPartners
  } = useProceduresPartners(id, 14);
  const [procedurePrices, setProcedurePrices] = useState({});
  const [editingProcedureId, setEditingProcedureId] = useState(null);
  const [myProcedures, setMyProcedures] = useState(false);
  const [procedures, setProcedures] = useState([]);
  const [updatedProcedures, setUpdatedProcedures] = useState(false);

  //mostrar meus procedimentos
  const handleMyProceduresClick = (checked) => {
    setMyProcedures(checked);
  };

  useEffect(() => {
    if (updatedProcedures) {
      api
        .post("/api/affiliatecompany/list/shopper/procedures/all", {
          shopper_id: 14,
          company_id: id,
        })
        .then((response) => {
          setProceduresPartners(response.data);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setLoading(false);
        });

      // Resetar o estado de atualização
      setUpdatedProcedures(false);
    }
  }, [updatedProcedures]);

  // Função para lidar com a atualização dos preços
  const handlePriceUpdated = (id, newCostPrice, newSellingPrice) => {
    setProcedurePrices((prevPrices) => ({
      ...prevPrices,
      [id]: {
        cost_price: newCostPrice,
        selling_price: newSellingPrice,
      },
    }));
  };

  // Função para filtrar os procedimentos com base no termo de pesquisa
  const filterProcedures = (searchTerm) => {
    if (!Array.isArray(proceduresPartners.procedures)) {
      return [];
    }
    const searchTermTrimmed = searchTerm.trim().toLowerCase();
    return proceduresPartners.procedures.filter((procedimento) => {
      const name = (procedimento.name || "").toLowerCase();
      const code = String(procedimento.own_code || "").toLowerCase();
      return (
        name.includes(searchTermTrimmed) || code.includes(searchTermTrimmed)
      );
    });
  };

  // Função para pesquisar quando o botão for pressionado
  const handleSearchClick = (e) => {
    e.preventDefault();

    // Filtra os procedimentos de acordo com o termo de pesquisa
    const filtered = filterProcedures(searchTerm);

    // Exibe todos os procedimentos
    setProcedures(filtered);

    // Atualiza a lógica de pesquisa para manter a seleção
    setSelectedProcedures((prev) => {
      const selectedIds = new Set(prev.map((proc) => proc.id));
      const remainingSelected = prev.filter(
        (proc) => !filtered.some((f) => f.id === proc.id)
      );
      return [
        ...remainingSelected,
        ...filtered.filter((proc) => selectedIds.has(proc.id)),
      ];
    });
    console.log("Dentro da função pesquisar: ", selectedProcedures);
    console.log(filtered);
  };

  const openModalEdit = (id) => {
    setEditingProcedureId(id); // Define o ID do procedimento em edição
    //setIsModalOpenEdit(true);
    // Marque o procedimento como selecionado quando for editado
    const procedimento = procedures.find((proc) => proc.id === id);
    if (procedimento) {
      setSelectedProcedures((prev) => {
        const isAlreadySelected = prev.find(
          (item) => item.id === procedimento.id
        );
        if (!isAlreadySelected) {
          return [...prev, procedimento];
        }
        return prev;
      });
    }
  };

  const closeModalEdit = () => {
    setEditingProcedureId(null);
    //setIsModalOpenEdit(false);
  };
  const handleProcedureUpdated = (updatedProcedure) => {
    setProcedures((prev) =>
      prev.map((proc) =>
        proc.id === updatedProcedure.id
          ? { ...proc, ...updatedProcedure }
          : proc
      )
    );

    setSelectedProcedures((prev) =>
      prev.map((proc) =>
        proc.id === updatedProcedure.id
          ? { ...proc, ...updatedProcedure }
          : proc
      )
    );

    closeModalEdit();
  };

  useEffect(() => {
    if (isModalOpen && Array.isArray(proceduresPartners.procedures)) {
      const filteredProcedures = filterProcedures(searchTerm);

      // Mantenha os procedimentos selecionados que ainda estão nos procedimentos filtrados
      const selectedIds = new Set(selectedProcedures.map((proc) => proc.id));
      const initiallySelected = filteredProcedures.filter(
        (proc) => selectedIds.has(proc.id) || proc.flag_exist
      );
      console.log("Procedimentos iniciais selecionados:", initiallySelected);
      console.log("Procedimentos selecionados:", selectedProcedures);
      setProcedures(filteredProcedures);
    }
  }, [isModalOpen, searchTerm, proceduresPartners]);

  // Função para atualizar os preços no estado
  const updateProcedurePrice = (id, field, value) => {
    const numericValue = parseFloat(value) || 0;
    setProcedurePrices((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: numericValue,
      },
    }));
    setSelectedProcedures((prev) =>
      prev.map((proc) =>
        proc.id === id ? { ...proc, [field]: numericValue } : proc
      )
    );
  };

  const toggleProcedureSelection = (procedimento) => {
    setSelectedProcedures((prev) => {
      const isSelected = prev.find((item) => item.id === procedimento.id);
      if (isSelected) {
        // Remove o procedimento se já estiver selecionado
        return prev.filter((item) => item.id !== procedimento.id);
      } else {
        // Adiciona o procedimento e inicializa os valores de preço
        const costPrice = procedurePrices[procedimento.id]?.cost_price || 0;
        const sellingPrice =
          procedurePrices[procedimento.id]?.selling_price || 0;
        return [
          ...prev,
          {
            ...procedimento,
            cost_price: costPrice,
            selling_price: sellingPrice,
          },
        ];
      }
    });
  };

  // Dentro da função confirmarProcedimentos
  const formattedProcedures =
    selectedProcedures?.map((proc) => ({
      id: proc.id,
      cost_price: procedurePrices[proc.id]?.cost_price || 0,
      selling_price: procedurePrices[proc.id]?.selling_price || 0,
      flag_delete: false,
    })) || [];

  // 63
  // Agora você pode usar dataToSave para salvar os procedimentos

  // Função para confirmar e salvar os procedimentos selecionados
  const confirmarProcedimentos = async () => {
    const hasInvalidPrices = selectedProcedures.some((proc) => {
      const costPrice = procedurePrices[proc.id]?.cost_price || 0;
      const sellingPrice = procedurePrices[proc.id]?.selling_price || 0;
      return costPrice <= 0 || sellingPrice <= 0;
    });

    if (hasInvalidPrices || selectedProcedures.length === 0) {
      Swal.fire({
        title: "Atenção",
        text: "Por favor, insira preços válidos para todos os procedimentos.",
        icon: "warning",
        confirmButtonColor: "#3c8dbc",
        confirmButtonText: "Ok",
      });
      return;
    }

    const formattedProcedures = selectedProcedures.map((proc) => ({
      id: proc.id,
      cost_price: parseFloat(procedurePrices[proc.id]?.cost_price || 0).toFixed(
        2
      ),
      selling_price: parseFloat(
        procedurePrices[proc.id]?.selling_price || 0
      ).toFixed(2),
      flag_delete: proc.flag_delete || false, // Inclui o flag_delete
    }));

    try {
      const response = await api.post(
        "/api/affiliatecompany/add/shopper/procedures/relationship",
        {
          id: id,
          shopper_id: 14,
          procedures: formattedProcedures,
        }
      );

      Swal.fire({
        title: "Procedimentos salvos com sucesso!",
        icon: "success",
      }).then(() => {
        setUpdatedProcedures(true);
      });

      console.log(response.data);
    } catch (error) {
      console.error("Erro ao salvar. Tente novamente.", error);
      alert("Erro ao salvar. Verifique os dados e tente novamente.");
    }
  };

  //Editar os procedimentos
  const handleEdit = (procedimento) => {
    // Implemente a lógica de edição aqui
    console.log("Editando procedimento:", procedimento);
  };
  //Excluir os procedimentos
  const handleDelete = async (procedimento) => {
    Swal.fire({
      title: "Tem certeza que deseja excluir este procedimento?",
      text: "Esta ação não pode ser desfeita.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, excluir",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Atualize o procedimento para definir flag_delete como true
          const updatedProcedure = {
            ...procedimento,
            flag_delete: true,
          };

          // Atualize o estado para refletir a alteração localmente
          setSelectedProcedures((prev) =>
            prev.map((proc) =>
              proc.id === updatedProcedure.id ? updatedProcedure : proc
            )
          );

          // Enviar a atualização para a API
          const response = await api.post(
            "/api/affiliatecompany/add/shopper/procedures/relationship",
            {
              id: id,
              shopper_id: 14,
              procedures: [updatedProcedure],
            }
          );

          Swal.fire({
            title: "Procedimento excluído com sucesso!",
            icon: "success",
          }).then(() => {
            //retirar o item da lista de selecionados
            setSelectedProcedures((prev) =>
              prev.filter((proc) => proc.id !== procedimento.id)
            );
            //remover os valores
            setProcedurePrices((prev) => {
              const newPrices = { ...prev };
              delete newPrices[procedimento.id];
              return newPrices;
            });
          });

          setUpdatedProcedures(true);
          console.log(response.data);
        } catch (error) {
          console.error("Erro ao excluir o procedimento.", error);
          alert("Erro ao excluir o procedimento. Tente novamente.");
        }
      }
      // Renderize novamente os procedimentos para sumir o que foi excluído
      setProcedures((prev) =>
        prev.filter((proc) => proc.id !== procedimento.id)
      );
    });
  };

  return (
    isModalOpen && (
      <div className="my-modal-overlay">
        <div className="my-modal">
          <div className="my-modal-header">
            <div className="my-modal-header-p1">
              <h2>Procedimentos: TODOS</h2>
              <div className="section-header">
                <input
                  type="text"
                  placeholder="Pesquisar"
                  className="form-control input-pesquisa"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearchClick(e);
                    }
                  }}
                />
              </div>
            </div>

            <div className="my-modal-header-switch">
              <div className="my-modal-header-p2">
                <button
                  type="button"
                  onClick={() => {
                    Swal.fire({
                      title: "Fechar",
                      text: "Tem certeza que deseja fechar?",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonText: "Sim",
                      cancelButtonText: "Cancelar",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        closeModal();
                      }
                    });
                  }}
                  className="my-modal-button-close">
                  X
                </button>
              </div>
              <div className="form-check form-switch d-flex align-items-center">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="proceduresSwitch"
                  checked={myProcedures}
                  onChange={(e) => handleMyProceduresClick(e.target.checked)}
                  style={{
                    width: "2.5rem",
                    height: "1.5rem",
                    cursor: "pointer",
                  }}
                />
                <label
                  className="ms-2 text-secondary"
                  htmlFor="proceduresSwitch">
                  {myProcedures
                    ? "Meus Procedimentos"
                    : "Todos os Procedimentos"}
                </label>
              </div>
            </div>
          </div>

          <section className="my-modal-body">
            <div className="my-modal-body-p1">
              {!myProcedures ? (
                <div>
                  <ul className="procedimentos-list">
                    {loadingPartners && <Loading />}
                    {!loadingPartners &&
                      procedures.length > 0 &&
                      procedures.map((procedimento) => (
                        <li key={procedimento.id} className="procedimento-item">
                          <div className="my-procedimento-item-p0">
                            <label className="procedimento-checkbox">
                              {procedimento.falg_exist ? (
                                <div>
                                  <input
                                    type="checkbox"
                                    id={`procedimento-${procedimento.id}`}
                                    defaultChecked={true}
                                    readOnly
                                  />
                                </div>
                              ) : (
                                <div>
                                  <input
                                    type="checkbox"
                                    id={`procedimento-${procedimento.id}`}
                                    checked={
                                      !!selectedProcedures.find(
                                        (item) => item.id === procedimento.id
                                      ) || procedimento.falg_exist
                                    }
                                    onChange={() =>
                                      toggleProcedureSelection(procedimento)
                                    }
                                  />
                                </div>
                              )}
                            </label>
                            <span className="my-procedimento-item-p1">
                              {procedimento.name || "Nome Indefinido"}
                            </span>
                          </div>
                          {!procedimento.falg_exist ? (
                            <div className="my-procedimento-item-p2">
                              <NumericFormat
                                className="input-p2"
                                placeholder="R$: Preço de Custo"
                                value={
                                  procedurePrices[procedimento.id]
                                    ?.cost_price || ""
                                }
                                thousandSeparator="."
                                decimalSeparator=","
                                prefix="R$ "
                                decimalScale={2}
                                fixedDecimalScale
                                onValueChange={(values) => {
                                  updateProcedurePrice(
                                    procedimento.id,
                                    "cost_price",
                                    values.value
                                  );
                                }}
                              />

                              <NumericFormat
                                className="input-p2"
                                placeholder="R$: Preço de Venda"
                                value={
                                  procedurePrices[procedimento.id]
                                    ?.selling_price || ""
                                }
                                thousandSeparator="."
                                decimalSeparator=","
                                prefix="R$ "
                                decimalScale={2}
                                fixedDecimalScale
                                onValueChange={(values) => {
                                  updateProcedurePrice(
                                    procedimento.id,
                                    "selling_price",
                                    values.value
                                  );
                                }}
                              />
                            </div>
                          ) : (
                            <div className="my-procedimento-item-p3">
                              <div className="my-procedimento-item-p3-precos">
                                <span>R$: {procedimento.cost_price || ""}</span>
                                <span>
                                  R$: {procedimento.selling_price || ""}
                                </span>
                              </div>
                              <div className="my-procedimento-item-p2">
                                <span
                                  className="my-procedimento-item-p2-edit"
                                  onClick={() =>
                                    openModalEdit(procedimento.id)
                                  }>
                                  <img width={28} src={editar} alt="Editar" />
                                </span>
                                <EditarProcedimento
                                  procedimento={procedimento}
                                  onOpen={
                                    editingProcedureId === procedimento.id
                                  }
                                  onClose={closeModalEdit}
                                  onPriceUpdated={handlePriceUpdated}
                                  onProcedureUpdated={handleProcedureUpdated}
                                />
                                <span
                                  className="my-procedimento-item-p2-excluir"
                                  onClick={() => handleDelete(procedimento)}>
                                  <img width={30} src={excluir} alt="Excluir" />
                                </span>
                              </div>
                            </div>
                          )}
                        </li>
                      ))}
                  </ul>
                </div>
              ) : (
                <div>
                  <ul className="procedimentos-list">
                    {loadingPartners && <Loading />}
                    {!loadingPartners &&
                      procedures
                        .filter((procedimento) => procedimento.falg_exist)
                        .map((procedimento) => (
                          <li
                            key={procedimento.id}
                            className="procedimento-item">
                            <div className="my-procedimento-item-p0">
                              <label className="procedimento-checkbox">
                                <input
                                  type="checkbox"
                                  id={`procedimento-${procedimento.id}`}
                                  checked={
                                    !!selectedProcedures.find(
                                      (item) => item.id === procedimento.id
                                    ) || procedimento.falg_exist
                                  }
                                  onChange={() =>
                                    toggleProcedureSelection(procedimento)
                                  }
                                />
                              </label>
                              <span className="my-procedimento-item-p1">
                                {procedimento.name || "Nome Indefinido"}
                              </span>
                            </div>
                            {!procedimento.falg_exist ? (
                              <div className="my-procedimento-item-p2">
                                <input
                                  className="input-p2"
                                  type="text"
                                  placeholder="R$: Preço de Custo1"
                                  value={
                                    procedurePrices[procedimento.id]
                                      ?.cost_price || ""
                                  }
                                  onChange={(e) =>
                                    updateProcedurePrice(
                                      procedimento.id,
                                      "cost_price",
                                      e.target.value
                                    )
                                  }
                                  mask="R$ 99.999,99"
                                  maskChar=" " // Espaço em branco no lugar do caractere de máscara
                                />

                                {/* Preço de Venda */}
                                <input
                                  className="input-p2"
                                  type="text"
                                  placeholder="R$: Preço de Venda1"
                                  value={
                                    procedurePrices[procedimento.id]
                                      ?.selling_price || ""
                                  }
                                  onChange={(e) =>
                                    updateProcedurePrice(
                                      procedimento.id,
                                      "selling_price",
                                      e.target.value
                                    )
                                  }
                                  mask="R$ 99.999,99"
                                  maskChar=" " // Espaço em branco no lugar do caractere de máscara
                                />
                              </div>
                            ) : (
                              <div className="my-procedimento-item-p3">
                                <div className="my-procedimento-item-p3-precos gap-3">
                                  <div className="d-flex flex-column align-items-center">
                                    <p>Preço Repasse (R$)</p>
                                    <span>{formatMoney(procedimento.cost_price) || ""} </span>
                                  </div>

                                  <div className="d-flex flex-column align-items-center">
                                    <p>Preço de Venda (R$)</p>
                                    <span>{formatMoney(procedimento.selling_price) || ""}</span>
                                  </div>
                                </div>

                                <div className="my-procedimento-item-p2">
                                  <span
                                    className="my-procedimento-item-p2-edit"
                                    onClick={() =>
                                      openModalEdit(procedimento.id)
                                    }>
                                    <img width={28} src={editar} alt="Editar" />
                                  </span>
                                  <EditarProcedimento
                                    procedimento={procedimento}
                                    onOpen={
                                      editingProcedureId === procedimento.id
                                    }
                                    onClose={closeModalEdit}
                                    onPriceUpdated={handlePriceUpdated}
                                    onProcedureUpdated={handleProcedureUpdated}
                                  />
                                  <span
                                    className="my-procedimento-item-p2-excluir"
                                    onClick={() => handleDelete(procedimento)}>
                                    <img
                                      width={30}
                                      src={excluir}
                                      alt="Excluir"
                                    />
                                  </span>
                                </div>
                              </div>
                            )}
                          </li>
                        ))}
                  </ul>
                </div>
              )}
            </div>
          </section>
          <div className="my-modal-footer">
            <button
              onClick={(e) => {
                e.preventDefault();
                Swal.fire({
                  title: "Deseja confirmar as alterações?",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Sim",
                  cancelButtonText: "Cancelar",
                }).then((result) => {
                  if (result.isConfirmed) {
                    if (selectedProcedures.length === 0) {
                      Swal.fire({
                        title: "Nenhuma alteração realizada",
                        icon: "info",
                        confirmButtonColor: "#3c8dbc",
                        confirmButtonText: "Ok",
                      });
                    } else {
                      confirmarProcedimentos();
                    }
                  }
                });
              }}
              className="my-confirm-button">
              Confirmar
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default ProcedimentosModal;
